/*
 * tp-druckerhinweis.js
 * ------------------------------------------------------------
 * Zeigt auf der Produktseite über dem Kaufknopf, ob der gemerkte Drucker des Besuchers
 * (window.tpMyPrinter.get(), aus tp-my-printer.js) zu diesem Artikel passt.
 * Die Drucker des Artikels stehen als JSON im Attribut data-drucker (Metafeld custom.kompatible_drucker,
 * je Eintrag n = Name, h = Handle der Druckerseite).
 *
 *   Treffer  → „Passt zu Ihrem Drucker: <Name>“, der Name verlinkt auf /collections/<h> (wie im Tab „Passend für“)
 *   sonst    → „<Name> steht nicht in der Druckerliste dieses Artikels.“ und der Link „Liste prüfen →“ (öffnet den Tab „Passend für“)
 *
 * Verglichen wird nur auf genau gleichen Namen (Groß-/Kleinschreibung, Leer- und Sonderzeichen egal), nie auf
 * Teilstücke: „6600“ darf nicht zu „OfficeJet Pro 6600e“ passen. Alles läuft im Browser, nichts wird gesendet.
 */
(function () {
  function squash(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9äöüß]+/g, '');
  }

  function init(root) {
    var printer = window.tpMyPrinter && window.tpMyPrinter.get && window.tpMyPrinter.get();
    if (!printer) return;

    var entries;
    try { entries = JSON.parse(root.getAttribute('data-drucker') || '[]'); } catch (e) { return; }
    if (!Array.isArray(entries) || !entries.length) return;

    var label = [printer.b, printer.s, printer.m].filter(Boolean).join(' ');
    var candidates = [
      squash(printer.b + printer.s + printer.m),
      squash(printer.b + printer.m),
      squash(printer.s + printer.m)
    ].filter(Boolean);
    var match = null;
    entries.forEach(function (e) {
      if (!match && e && candidates.indexOf(squash(e.n)) !== -1) match = e;
    });
    var passt = !!match;

    var icon = root.querySelector('[data-tp-dh-icon]');
    var text = root.querySelector('[data-tp-dh-text]');
    var aktion = root.querySelector('[data-tp-dh-aktion]');
    if (!icon || !text) return;

    text.textContent = '';
    if (aktion) aktion.textContent = '';
    if (passt) {
      icon.textContent = '✓';
      text.appendChild(document.createTextNode('Passt zu Ihrem Drucker: '));
      var strong = document.createElement('strong');
      var handle = match.h ? String(match.h) : '';
      if (/^[a-z0-9-]+$/i.test(handle)) {
        var a = document.createElement('a');
        a.className = 'tp-druckerhinweis__name';
        a.href = '/collections/' + handle;
        a.textContent = label;
        strong.appendChild(a);
      } else {
        strong.textContent = label;
      }
      text.appendChild(strong);
    } else {
      icon.textContent = '!';
      var name = document.createElement('strong');
      name.textContent = label;
      text.appendChild(name);
      text.appendChild(document.createTextNode(' steht nicht in der Druckerliste dieses Artikels.'));
      var tab = document.getElementById('tp-pd-tab-passend');
      if (tab && aktion) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'tp-druckerhinweis__link';
        b.textContent = 'Liste prüfen →';
        b.addEventListener('click', function () {
          tab.click();
          tab.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
        aktion.appendChild(b);
      }
    }
    root.setAttribute('data-status', passt ? 'passt' : 'pruefen');
    root.hidden = false;
  }

  function start() {
    var nodes = document.querySelectorAll('[data-tp-druckerhinweis]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
